import { InputTextType } from '../common/InputType'
import { SelectType } from '../components/UtilComponent/level_1/SelectBox'
import { AddressInputType } from '../components/UtilComponent/level_3/AddressInput'
import { countries } from '../data/country'
import { prefectures } from '../data/prefectures'
import { CONTACT_FIELD_MAX_LENGTH } from './../util/contactFieldLimits'

const useAddressInput = (address: AddressInputType) => {
  const {
    country,
    setCountry,
    prefecture,
    setPrefecture,
    postalCode,
    setPostalCode,
    city,
    setCity,
    address1,
    setAddress1,
    address2,
    setAddress2,
  } = address

  const countryOptions = Object.entries(countries).map(([key, value]) => (
    <option value={key} key={key}>
      {value}
    </option>
  ))

  // 国が日本かどうか。日本のときのみ都道府県をプルダウンで選択させる
  const isJapan = country === 'japan'

  // 国を変更したときは、それまでの都道府県（日本のキー or 自由入力文字列）をリセットする。
  // これにより「日本→他国」「他国→日本」の切り替え時に前の値が残らない。
  const handleCountryChange = (value: string) => {
    setCountry(value)
    setPrefecture('')
  }

  const countrySelect: SelectType = {
    id: 'country',
    autoComplete: 'country-name',
    label: '',
    state: country,
    setState: handleCountryChange,
    options: countryOptions,
  }

  const prefectureOptions = Object.entries(prefectures).map(([key, value]) => (
    <option value={key} key={key}>
      {value}
    </option>
  ))

  const prefectureSelect: SelectType = {
    id: 'prefecture',
    autoComplete: 'none',
    label: '',
    state: prefecture,
    setState: setPrefecture,
    options: prefectureOptions,
  }

  // 日本以外の国を選択した場合に使用する、都道府県（州・地域）の自由入力欄。
  // 入力した文字列がそのまま prefecture として送信される。
  const prefectureInput: InputTextType = {
    type: 'text',
    id: 'prefecture',
    label: '',
    placeholder: '州・地域など',
    required: false,
    autoComplete: 'none',
    state: prefecture,
    setState: setPrefecture,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.prefecture,
  }

  const postalCodeInput: InputTextType = {
    type: 'text',
    id: 'postalCode',
    label: '',
    placeholder: '郵便番号',
    required: false,
    autoComplete: 'postal-code',
    state: postalCode,
    setState: setPostalCode,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.postalCode,
  }

  const cityInput: InputTextType = {
    type: 'text',
    id: 'city',
    label: '',
    placeholder: '市区郡町村...',
    required: false,
    autoComplete: 'none',
    state: city,
    setState: setCity,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.city,
  }

  const address1Input: InputTextType = {
    type: 'text',
    id: 'address1',
    label: '',
    placeholder: '住所1（町丁・字以降）...',
    required: false,
    autoComplete: 'none',
    state: address1,
    setState: setAddress1,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.address1,
  }

  const address2Input: InputTextType = {
    type: 'text',
    id: 'address2',
    label: '',
    placeholder: '住所2（建物名など）...',
    required: false,
    autoComplete: 'none',
    state: address2,
    setState: setAddress2,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.address2,
  }

  return {
    isJapan,
    countrySelect,
    prefectureSelect,
    prefectureInput,
    postalCodeInput,
    cityInput,
    address1Input,
    address2Input,
  }
}

export default useAddressInput
